<template>
	<div class="section">
		<div class="box">
			<div class="boxheader">
				<div class="box_left">
					<img
						:src="dataListDatasMessage.Introduction.fileid"
						alt=""
					/>
					<div class="imgtitle">
						{{ dataListDatasMessage.Introduction.ChnName }}
					</div>
				</div>
				<div class="box_right">
					<div
						class="box_rightrightone"
						v-if="dataListDatasMessage.Introduction"
					>
						<div class="box_right_title">专题导读</div>
						<!-- <div
							class="box_right_content"
							v-if="rightContent.length <= 120"
						>
							{{ rightContent }}
						</div> -->
						<div class="box_right_content">
							{{
								viewNow &&
								dataListDatasMessage.Introduction.Introduction
									? dataListDatasMessage.Introduction.Introduction.slice(
											0,
											95
									  ) + '...'
									: dataListDatasMessage.Introduction
											.Introduction
							}}
							<span
								v-if="viewNow"
								style="display:inline"
								class="detail1"
								@click="viewNow = false"
								>&lt;查看全部&gt;</span
							>
							<span
								v-else
								style="display:inline"
								class="detail1"
								@click="viewNow = true"
								>&lt;折叠&gt;</span
							>
						</div>
					</div>
					<div v-if="viewNow == true" class="box_rightrighttwo">
						<div class="box_right_title">
							背景文章：<a
								class="qwLink"
								v-if="dataListDatasMessage.article"
								:href="
									'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnId=' +
										dataListDatasMessage.article.chnid +
										'&docid=' +
										dataListDatasMessage.article.docid +
										'&leafid=' +
										dataListDatasMessage.article.leafid
								"
								target="_blank"
								>{{ dataListDatasMessage.article.subject }}</a
							>
						</div>
						<div class="box_right_content">
							<a
								id="fineDocUrl"
								v-if="dataListDatasMessage.article"
								:href="
									'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnId=' +
										dataListDatasMessage.article.chnid +
										'&docid=' +
										dataListDatasMessage.article.docid +
										'&leafid=' +
										dataListDatasMessage.article.leafid
								"
								target="_blank"
								class="zh_text"
							>
								<span id="fineDocContent" class="zh_text"
									>{{
										dataListDatasMessage.article.summary &&
										dataListDatasMessage.article.summary
											.length > 120
											? dataListDatasMessage.article.summary.slice(
													0,
													120
											  ) + '...'
											: dataListDatasMessage.article
													.summary
									}}<span
										style="display:inline"
										class="detail1"
										>&lt;全文&gt;</span
									></span
								>
							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="boxContent">
				<div
					class="boxContent_block"
					v-if="dataListDatas"
					v-for="(item, index) in dataListDatas"
					:key="index"
				>
					<div class="boxContent_block_title">
						<img
							class="boxContent_block_title_icon"
							src="../../../assets/hot/titleicon.png"
							alt=""
						/>
						<div class="boxContent_block_title_name">
							{{ item.name }}
						</div>
						<div class="image-container">
							<img
								class="boxContent_block_title_line"
								src="../../../assets/hot/titlebg.png"
								alt=""
							/>
						</div>

						<div
							class="article_l_more"
							@click="more(item.name, item)"
						>
							more
							<img
								src="../../../assets/hot/icon_more.png"
								alt=""
							/>
						</div>
					</div>
					<div class="boxContent_block_list">
						<div
							class="boxContent_block_list_l"
							v-if="item.value.data"
						>
							<div
								class="boxContent_block_list_row"
								v-for="(item, index) in item.value.data.slice(
									0,
									5
								)"
								:key="index"
							>
								<div class="boxContent_block_list_rowIcon">
									<img
										src="../../../assets/hot/listtitle.png"
										alt=""
										@click="gotoDocDetail(item)"
									/>
								</div>
								<div
									class="boxContent_block_list_rowCt"
									:title="item.title"
									@click="gotoDocDetail(item)"
								>
									{{ item.title }}
								</div>
								<div class="boxContent_block_list_rowTime">
									{{ item.deliveddate.slice(0, 10) }}
								</div>
							</div>
						</div>
						<div
							class="boxContent_block_list_r"
							v-if="item.value.data && item.value.data.length > 5"
						>
							<div
								class="boxContent_block_list_row"
								v-for="(item, index) in item.value.data.slice(
									5,
									10
								)"
								:key="index"
							>
								<div class="boxContent_block_list_rowIcon">
									<img
										src="../../../assets/hot/listtitle.png"
										alt=""
										@click="gotoDocDetail(item)"
									/>
								</div>
								<div
									class="boxContent_block_list_rowCt"
									:title="item.title"
									@click="gotoDocDetail(item)"
								>
									{{ item.title }}
								</div>
								<div class="boxContent_block_list_rowTime">
									{{ item.deliveddate.slice(0, 10) }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="boxContent_block">
					<div class="boxContent_block_title">
						<img
							class="boxContent_block_title_icon"
							src="../../../assets/hot/titleicon.png"
							alt=""
						/>
						<div class="boxContent_block_title_name">
							专题推荐
						</div>
						<div class="image-container">
							<img
								class="boxContent_block_title_line"
								src="../../../assets/hot/titlebg.png"
								alt=""
							/>
						</div>
						<div class="article_l_more" @click="moreZT()">
							<div>more</div>
							<img
								src="../../../assets/hot/icon_more.png"
								alt=""
							/>
						</div>
					</div>
					<div class="boxContent_block_list_ZT">
						<div class="boxContent_block_list_l_ZT" v-if="newList">
							<div
								class="boxContent_block_list_row_ZT"
								v-for="(item, index) in newList.slice(0, 3)"
								:key="index"
								@click="gotoDocDetailZT(item)"
							>
								<div class="boxContent_block_list_rowIcon_ZT">
									<img :src="item.fileId" alt="" />
								</div>
								<div class="boxContent_block_list_rowCt_ZT_r">
									<div
										class="boxContent_block_list_rowTime_ZT"
										:title="item.chnName"
									>
										{{ item.chnName }}
									</div>
									<div
										class="boxContent_block_list_rowCt_ZT"
										:title="item.introduction"
									>
										{{ item.introduction }}
									</div>
								</div>
							</div>
						</div>
						<div
							class="boxContent_block_list_r_ZT"
							v-if="newList && newList.length > 3"
						>
							<div
								class="boxContent_block_list_row_ZT"
								v-for="(item, index) in newList.slice(3, 6)"
								:key="index"
								@click="gotoDocDetailZT(item)"
							>
								<div class="boxContent_block_list_rowIcon_ZT">
									<img :src="item.fileId" alt="" />
								</div>
								<div class="boxContent_block_list_rowCt_ZT_r">
									<div
										class="boxContent_block_list_rowTime_ZT"
										:title="item.chnName"
									>
										{{ item.chnName }}
									</div>
									<div
										class="boxContent_block_list_rowCt_ZT"
										:title="item.introduction"
									>
										{{ item.introduction }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: '',
	components: {},
	mixins: [],
	props: [
		'dataListTwo',
		'dataListDatas',
		'dataListDatasMessage',
		'newList',
		'totlalCount',
	],
	data() {
		return {
			viewNow: true,
		};
	},
	computed: {},
	watch: {
		dataListDatas(val) {
			//console.log(val);
		},
		newList(val) {
			// //console.log(val);
		},
	},
	created() {
		// //console.log(this.dataListDatas);
	},
	mounted() {
		// //console.log(this.dataListDatas);
		// window.scrollTo(0, 0);
	},
	methods: {
		viewAllmodel() {
			//判断显不显示
			this.viewNow = !viewNow;
		},
		gotoDocDetail(item) {
			//打开文章
			window.open(
				'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnId=' +
					item.chnid +
					'&docid=' +
					item.docid +
					'&leafid=' +
					item.leafid
			);
			// this.$router.push({
			// 	path:
			// 		'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx',
			// 	query: {
			// 		chnId: item.chnId,
			// 		docid: item.docid,
			// 		leafid: item.leafid,
			// 	},
			// });
		},
		gotoDocDetailZT(item) {
			event.stopPropagation();
			window.location.href = '#/hotdetail?chnId=' + item.chnId;
			this.$bus.$emit('goReload', true);

			// this.$router.push({
			// 	path: '/hotdetail',
			// 	query: { chnId: item.chnId },
			// });
			// location.reload();
			// this.$nextTick(function() {
			// 	window.scrollTo(0, 0);
			// });
			// window.scrollTo(0, 0);
			// window.open('#/hotdetail?chnId=' + item.chnId, '_self');
			// //console.log(item);
		},
		moreZT() {
			//更多热点
			this.$router.push({
				path: '/hotColumn?id=231&name=热点专题&uid=7392&showType=2',
			});
			window.scrollTo(0, 0);
		},
		more(itemname, items) {
			//导航的内容
			// //console.log(items);
			this.$bus.$emit('bMsg', { msg: itemname, items: items.items });
			window.scrollTo(0, 0);
		},
	},
};
</script>
<style lang="less" scoped>
.box {
	width: 1440px;
	margin: 31px auto 78px auto;
	background: #f7f7f7;
	.boxheader {
		background: #fff;
		display: flex;
		height: 416px;
		.box_left {
			position: relative;
			img {
				width: 744px;
				height: 100%;
			}
			.imgtitle {
				position: absolute;
				bottom: 16px;
				left: 23px;
				font-size: 19px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #ffffff;
				cursor: pointer;
			}
			.imgtitle:hover {
				text-decoration: underline;
			}
		}
		.box_right {
			background: url(../../../assets/hot/text_bg.png) no-repeat right
				bottom #fff;
			overflow: hidden;
			padding: 52px 43px 53px 47px;
			.box_right_title {
				font-size: 18px;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: #181818;
				.qwLink {
					color: #181818;
				}
				.qwLink:hover {
					color: rgb(71, 71, 250);
				}
			}

			.box_right_content {
				font-size: 17px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #444444;
				line-height: 31px;
				display: block;
				text-indent: 28px;
				overflow: hidden;
				overflow-y: auto;
				max-height: 276px;
				.zh_text {
					font-size: 17px;
					color: #444444;
				}
				.detail1 {
					cursor: pointer;
					color: #139900;
				}
				scrollbar-width: thin; /* 设置滚动条宽度 */
				scrollbar-color: #ccc #f4f4f4; /* 设置滚动条颜色 */
				&::-webkit-scrollbar {
					width: 8px; /* 设置滚动条宽度 */
				}
				&::-webkit-scrollbar-track {
					background: #f4f4f4; /* 设置滚动条轨道背景色 */
				}
				&::-webkit-scrollbar-thumb {
					background-color: #ccc; /* 设置滚动条滑块颜色 */
					border-radius: 10px; /* 设置滑块圆角 */
				}

				/* Firefox */
				& {
					scrollbar-width: thin; /* 设置滚动条宽度 */
					scrollbar-color: #ccc #f4f4f4; /* 设置滚动条颜色 */
				}
			}
			.box_rightrightone {
				margin-bottom: 53px;
			}
		}
	}
}
.boxContent {
	background: #fff;
	margin-top: 42px;
	padding: 32px 0 50px 0;
	.boxContent_block {
		.boxContent_block_title {
			display: flex;
			margin: 0px 22px 0 32px;
			// padding-top: 32px;
			align-items: center;
			.boxContent_block_title_icon {
			}

			.boxContent_block_title_name {
				// flex-grow: 1;
				margin: 0 13px 0 8px;
				font-size: 22px;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: #181818;
				white-space: nowrap;
				// overflow: hidden;
				// text-overflow: ellipsis;
			}
			.article_l_more {
				display: inline-block;
				width: 70px;
				float: right;
				cursor: pointer;
				font-size: 17px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #444444;
				line-height: 0px;
				&:hover {
					color: rgb(31, 31, 212);
				}
			}
			.article_l_more img {
				// margin-left: 4px;
				vertical-align: top;
				float: right;
			}
			.image-container {
				flex-shrink: 1;
				height: 18px;
				overflow: hidden;
				margin-left: 10px; /* 根据需要设置标题和图片之间的间距 */
				margin-right: 10px;
				img {
					width: 99%;
					height: 18px;
				}
			}

			// .boxContent_block_title_line {
			// 	flex-shrink: 0;
			// 	// width: auto;
			// 	height: 18px;
			// 	margin-right: 13px;
			// }
		}
		.boxContent_block_list {
			display: flex;
			.boxContent_block_list_l {
				width: 50%;
				padding: 37px 0 56px 0;
			}
			.boxContent_block_list_r {
				width: 50%;
				padding: 37px 0 56px 0;
			}
			.boxContent_block_list_row {
				display: flex;
				margin-left: 43px;
				align-items: center;
				width: 100%;

				img {
					width: 7px;
					height: 12px;
					margin-right: 12px;
				}
				font-size: 17px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #333333;
				max-height: 47px;
				line-height: 47px;
				.boxContent_block_list_rowIcon {
					border-bottom: 1px dashed #e1e1e1;
					cursor: pointer;
				}
				.boxContent_block_list_rowCt {
					cursor: pointer;
					width: 500px;
					max-width: 500px;
					padding-right: 20px;
					white-space: nowrap;
					overflow: hidden; //这个是设置隐藏的。还有其他的，例如scroll，是超出固定长度，底部显示滚动条的。
					text-overflow: ellipsis; //这个就是设置直接隐藏掉文字，还是显示...的。当前是显示省略号。直接省略是clip
					display: inline-block; //根据不同标签display值，有的不用加。
					border-bottom: 1px dashed #e1e1e1;
					&:hover {
						color: rgb(93, 93, 245);
					}
				}
				.boxContent_block_list_rowTime {
					color: #929292;
					min-width: 90px;
					float: right;
					border-bottom: 1px dashed #e1e1e1;
				}
			}
		}

		.boxContent_block_list_ZT {
			display: flex;
			.boxContent_block_list_l_ZT {
				width: 50%;
				padding: 37px 0 0 0;
			}
			.boxContent_block_list_r_ZT {
				width: 50%;
				padding: 37px 0 0 0;
			}
			.boxContent_block_list_row_ZT {
				display: flex;
				margin-left: 43px;
				margin-bottom: 43px;
				width: 100%;

				cursor: pointer;

				img {
					width: 90px;
					height: 66px;
					margin-right: 18px;
				}
				font-size: 17px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #333333;
				max-height: 66px;
				line-height: 21px;
				.boxContent_block_list_rowIcon_ZT {
				}
				.boxContent_block_list_rowCt_ZT {
					width: 520px;
					max-width: 520px;
					// padding-right: 20px;
					// white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					-webkit-line-clamp: 2; //这里就是设置超出几行隐藏
					-webkit-box-orient: vertical;
					display: -webkit-box;
				}
				.boxContent_block_list_rowTime_ZT {
					font-size: 18px;
					font-family: Microsoft YaHei;
					font-weight: bold;
					color: #181818;
					width: 520px;
					max-width: 520px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					display: inline-block;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/hotcolumn/hotdetail/detail1Model.vue